// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"610":"e37bc589efca4e46","993":"88696ccef905ab30"}[chunkId] + ".js";
};